import _ from 'lodash'

export function validateEmail(email: string): boolean {
  const format = new RegExp(
    '^([A-Za-z0-9-_.]{1,})@([a-z0-9-]{1,})[.]([.a-z0-9-]{1,})$',
  )
  return format.test(email) || email === ''
}

export function validateDomain(domain: string): boolean {
  const format = new RegExp(
    '^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$',
  )
  return format.test(domain) || domain === ''
}

export function validateText(text: string): boolean {
  const format = new RegExp('^([A-Za-z0-9-_.]{1,})$')
  return format.test(text) || text === ''
}

export function convertMoney(money: number): number {
  return _.ceil(money / 100, 2)
}

export function checkRule(rules: any[], value: string): boolean {
  const lists = _.map(
    rules,
    (item: any) => {
      return typeof item(value) === 'string'
    },
  )
  return _.includes(lists, true)
}

// export function replaceAll(regExp: string, txt: string, char: string) {
//   while (regExp.test(txt)) {
//     txt = txt.replace(regExp, char)
//   }
//   return txt
// }

export function getTagLinks(code: string): RegExpMatchArray {
  const regex = new RegExp(/href="(.+?)"\s/g)
  let result = code.match(regex)
  result = _.map(result, (data: string) => data.substring(6, data.length - 2))
  return result
}

/**
 * condition list 1.upperChar 2.lowerChar 3. numberChar 4.specialChar 5.eighthChar
 * @returns Array of condition that valid
 */
export function checkPasswordValidate(password: string): string[] {
  const listOfValidCondition: string[] = []
  const regUpper = new RegExp(/[A-Z]/)
  const regLower = new RegExp(/[a-z]/)
  const regNum = new RegExp(/[0-9]/g)
  const regSpecial = new RegExp(/[$-/:-?@#{-~!"^_`\[\]]/g)
  const regTesting = (reg: RegExp): boolean => reg.test(password)

  if (regTesting(regUpper)) {
    listOfValidCondition.push('upperChar')
  }
  if (regTesting(regLower)) {
    listOfValidCondition.push('lowerChar')
  }
  if (regTesting(regNum)) {
    listOfValidCondition.push('numberChar')
  }
  if (regTesting(regSpecial)) {
    listOfValidCondition.push('specialChar')
  }
  if (password.length >= 8) {
    listOfValidCondition.push('eighthChar')
  }

  return listOfValidCondition
}
